import React from "react";
import styles from "./RegistLeader.module.scss";
import { sendEventTracking } from "../utils/GeneralUtils";
import SonicLink from "./routing/SonicLink";

type Props = {
  message?: string;
  trackingLabel?: string;
};

const RegistLeader: React.FC<Props> = ({ message, trackingLabel }) => {
  return (
    <div className={styles["c-regist-leader"]}>
      <SonicLink
        to="/register"
        onClick={() =>
          trackingLabel && sendEventTracking("click", trackingLabel, "register")
        }
      >
        <div>{message}</div>
        <span>新規会員登録はこちら</span>
      </SonicLink>
    </div>
  );
};

export default RegistLeader;
